import React from 'react';
import ConvictionWidgetBuilder from './ConvictionWidgetBuilder';
import ConvictionWidgetRenderer from './ConvictionWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { ConvictionWidgetConfig, ConvictionDataContent } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';

export { default as ConvictionWidgetBuilder } from './ConvictionWidgetBuilder';
export { default as ConvictionWidgetRenderer } from './ConvictionWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'conviction',
  meta: {
    label: 'Conviction Score',
    icon: React.createElement(FontAwesomeIcon, { icon: faBullseye }),
    description: 'Rate investment conviction with scoring system',
    isSystem: true,
    isCreatable: false,
    shareable: true,
    editableInWorkflow: true,
    dataFlow: 'input',
  },
  defaultSize: { w: 6, h: 5, minW: 3, minH: 3 },
  defaultConfig: () => ({
    showLabels: true,
    allowComments: true,
  } as ConvictionWidgetConfig),
  Builder: ConvictionWidgetBuilder,
  Renderer: ConvictionWidgetRenderer,
  Preview,
  validate: (data: unknown): string[] => {
    const convData = data as ConvictionDataContent | undefined;
    if (!convData?.categories?.length) return [];
    const errors: string[] = [];
    convData.categories.forEach(cat => {
      if (cat.score === undefined || cat.score === null) {
        errors.push(`Category "${cat.name}" requires a score`);
      }
    });
    return errors;
  },
};
